import API from '@API/index'
import { StreamUptime } from '@classes/StreamUptime';

async function getStreamUptime(stream: VideoStream | VideoStream[], credentials: any, start?: Date, end?: Date): Promise<VideoStreamTimeChunk[]> {
  try {
    const streamUptime: StreamUptime = new StreamUptime(
      stream,
      credentials,
      API.CloudWatch,
      API.Streams,
      start,
      end
    )

    return await streamUptime.build();
  } catch (error: any) {
    throw error;
  }
}

export default getStreamUptime;
